import { setInActive } from './states';

export const services = {
  setInActive,
};
